import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'
import { isInstrumentNotFoundError, isInstrumentPausedError } from '../lib/instrument-info-state'
import { SpSurveyPath } from '../lib/sp-survey-paths'
import type { ProviderInstrumentInfo, ProviderInstrumentStatus } from '../lib/types'

export function useProviderInstrumentInfo(instrumentId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.spInstrument.info(instrumentId ?? ''),
    enabled: Boolean(instrumentId),
    retry: (failureCount, error) =>
      !isInstrumentNotFoundError(error) && failureCount < 3,
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ProviderInstrumentInfo>>(
        SpSurveyPath.instrumentInfo(instrumentId!),
      )
      return data.data
    },
  })
}

export function useProviderInstrumentStatus(instrumentId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.spInstrument.status(instrumentId ?? ''),
    enabled: Boolean(instrumentId),
    retry: (failureCount, error) =>
      !isInstrumentPausedError(error) && failureCount < 3,
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ProviderInstrumentStatus>>(
        SpSurveyPath.instrumentStatus(instrumentId!),
      )
      return data.data
    },
  })
}
